import { useMemo } from "react";

import { usePinned } from "fond/views/Accounts/hooks/usePinned";

/**
 * Custom hook to sort pinned accounts.
 * Non pinned accounts are excluded if pinned accounts exist, otherwise all accounts are shown.
 */
export const useSortedAccounts = <T extends { ID: string }>(accounts: T[]): T[] => {
  const { pinned: pinnedAccountIds } = usePinned();

  return useMemo(() => {
    const pinnedAccounts = accounts.filter((account) => pinnedAccountIds.includes(account.ID));

    // If there are pinned accounts, show only those sorted by pinned order
    // Otherwise show all accounts
    let displayAccounts = pinnedAccounts.length > 0 ? pinnedAccounts : accounts;

    // Sort pinned accounts based on their order in pinnedAccountIds array
    if (pinnedAccounts.length > 0) {
      displayAccounts = displayAccounts.sort((a, b) => {
        const indexA = pinnedAccountIds.indexOf(a.ID);
        const indexB = pinnedAccountIds.indexOf(b.ID);
        return indexA - indexB;
      });
    }

    return displayAccounts;
  }, [accounts, pinnedAccountIds]);
};
